import { combineReducers } from 'redux'

import users from './organizations/users.reducer'

export default combineReducers({
  users
})
